export const NotificationType = {
  // Buy box notifications
  BUY_BOX_MATCH: 'BUY_BOX_MATCH',

  // Bid notifications
  NEW_BID: 'NEW_BID',
  BID_ACCEPTED: 'BID_ACCEPTED',
  BID_DECLINED: 'BID_DECLINED',
  BID_COUNTERED: 'BID_COUNTERED',
  BID_MESSAGE: 'BID_MESSAGE',
  BID_WON: 'BID_WON',
  // PRD 6.4: the seller accepted another offer; the buyer's offer is held as a backup
  BID_BACKUP: 'BID_BACKUP',

  // Connection notifications
  CONNECTION_REQUEST: 'CONNECTION_REQUEST',
  CONNECTION_ACCEPTED: 'CONNECTION_ACCEPTED',

  // Listing notifications
  LISTING_TAG: 'LISTING_TAG',
  LISTING_BACK_ON_MARKET: 'LISTING_BACK_ON_MARKET',

  // Verification notifications
  ENTITY_VERIFIED: 'ENTITY_VERIFIED',
  VERIFICATION_REJECTED: 'VERIFICATION_REJECTED',
  DOCUMENT_APPROVED: 'DOCUMENT_APPROVED',
  DOCUMENT_REJECTED: 'DOCUMENT_REJECTED',
  TIER_UPGRADED: 'TIER_UPGRADED',

  // Legacy types (kept for backwards compatibility)
  BID_STATUS_CHANGE: 'BID_STATUS_CHANGE',
  NEW_MESSAGE: 'NEW_MESSAGE',
} as const;

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export const DeliveryMode = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;

export type DeliveryMode = (typeof DeliveryMode)[keyof typeof DeliveryMode];

export const RelatedEntityType = {
  LISTING: 'LISTING',
  BID: 'BID',
  MESSAGE: 'MESSAGE',
  VERIFICATION: 'VERIFICATION',
} as const;

export type RelatedEntityType = (typeof RelatedEntityType)[keyof typeof RelatedEntityType];

export interface NotificationDto {
  id: string;
  userId: string;
  type: NotificationType;
  relatedEntityType: RelatedEntityType | null;
  relatedEntityId: string | null;
  title: string;
  message: string;
  data: Record<string, unknown> | null;
  isRead: boolean;
  readAt: string | null;
  emailSent: boolean;
  emailSentAt: string | null;
  smsSent: boolean;
  smsSentAt: string | null;
  smsDeliveryStatus: string | null;
  smsMessageId: string | null;
  createdAt: string;
}

export interface NotificationsResponseDto {
  notifications: NotificationDto[];
  total: number;
  page: number;
  totalPages: number;
  unreadCount: number;
}

export interface UnreadCountResponseDto {
  count: number;
}

export interface GetNotificationsOptions {
  type?: NotificationType;
  isRead?: boolean;
  page?: number;
  limit?: number;
}

// Notification Preferences Types
export interface NotificationPreferenceDto {
  notificationType: NotificationType;
  emailEnabled: boolean;
  deliveryMode: DeliveryMode;
}

export interface UpdatePreferenceItemDto {
  notificationType: NotificationType;
  emailEnabled: boolean;
  deliveryMode?: DeliveryMode;
}

export interface UpdatePreferencesDto {
  preferences: UpdatePreferenceItemDto[];
}
